export function getErrorMessage({ errorCode, translate }) {
  if (!errorCode) return null;

  switch (errorCode) {
    case 1001:
      return translate('errorMessage.noMatches');
    case 1002:
      return translate('errorMessage.invalidStatusOnly');
    case 1003:
      return translate('errorMessage.bookingsFountNoneMatch');
    case 400:
      return translate('errorMessage.validationError');
    case 401:
      return translate('errorMessage.unauthorized');
    case 403:
      return translate('errorMessage.connectionRefused');
    case 404:
      return translate('errorMessage.bookingNotFound');
    case 408:
      return translate('errorMessage.connectionTimeout');
    case 409:
      return translate('errorMessage.reservationNotModified');
    case 500:
      return translate('errorMessage.apiGatewayError');
    case 503:
      return translate('errorMessage.connectionNoResponse');

    default:
      return translate('errorMessage.noMatches');
  }
}
